import(/* webpackMode: "eager" */ "/home/runner/work/DSDashboard/DSDashboard/src/app/error.js");
